import { FC, ReactElement } from 'react'

import { useToken } from '@hooks'
import styled from 'styled-components'

import { Color } from '../../../../../generated/quicktype/Tokens'
import { GlobalStyle } from '../../global-style'

export interface FlexBoxProps {
  children?: ReactElement
}

const MainWrap = styled.div<Color>`
  width: 100dvw;
  height: 100dvh;
  display: flex;
  padding-bottom: 7dvh;
  background-color: ${(color) => color.bg.page.value};
`
const Container = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  max-width: 1920px;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-y: scroll;
`
export const FlexBoxCenteredLandingLayout: FC<FlexBoxProps> = (props) => (
  <MainWrap {...useToken().color}>
    <GlobalStyle />
    <Container>{props.children} </Container>
  </MainWrap>
)
